export const payrollOverviewDetailsRoutes = [
  {
    path: ':id',
    name: 'payroll-overview-details',
    component: () =>
      import(/* webpackChunkName: "payroll-overview-details" */ './PayrollOverviewDetails.vue')
  }
];
